import classNames from 'classnames'

import { Condition1Art } from '../Condtion1Art/Condition1Art'
import { Label } from '../Label'
import { StarAnim } from '../StarAnim'
import styles from './ConditionCard.module.scss'
import { CONDITION_ART_STEPS, type ConditionStep } from '../../constants'

interface ConditionCardProps {
  count: number
  label: string
  step: ConditionStep
  locked?: boolean
}

const BallsThree = () => (
  <div className={styles.ballWrap}>
    <div className={styles.ballsRow}>
      <div className={classNames(styles.ball, styles.ballSm)}>
        <div className={styles.eyes}>
          <div className={styles.eye} />
          <div className={styles.eye} />
        </div>
      </div>
      <div className={classNames(styles.ball, styles.ballMd)}>
        <div className={styles.eyes}>
          <div className={styles.eye} />
          <div className={styles.eye} />
        </div>
      </div>
      <div className={classNames(styles.ball, styles.ballSm)}>
        <div className={styles.eyes}>
          <div className={styles.eye} />
          <div className={styles.eye} />
        </div>
      </div>
    </div>
  </div>
)

const BallsFive = () => (
  <div className={styles.ballWrap}>
    <div className={styles.ballsGrid}>
      <div className={styles.ballsRow}>
        <div className={classNames(styles.ball, styles.ballSm)}>
          <div className={styles.eyes}>
            <div className={styles.eye} />
            <div className={styles.eye} />
          </div>
        </div>
        <div className={classNames(styles.ball, styles.ballMd)}>
          <div className={styles.eyes}>
            <div className={styles.eye} />
            <div className={styles.eye} />
          </div>
        </div>
        <div className={classNames(styles.ball, styles.ballSm)}>
          <div className={styles.eyes}>
            <div className={styles.eye} />
            <div className={styles.eye} />
          </div>
        </div>
      </div>
      <div className={styles.ballsRow}>
        <div className={classNames(styles.ball, styles.ballSm)}>
          <div className={styles.eyes}>
            <div className={styles.eye} />
            <div className={styles.eye} />
          </div>
        </div>
        <div className={classNames(styles.ball, styles.ballSm)}>
          <div className={styles.eyes}>
            <div className={styles.eye} />
            <div className={styles.eye} />
          </div>
        </div>
      </div>
    </div>
  </div>
)

const BallsMany = () => (
  <div className={styles.ballWrap}>
    <div className={styles.ballsCloud}>
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i} className={classNames(styles.ball, styles.ballXs)} />
      ))}
    </div>
  </div>
)

function renderBalls(count: number) {
  if (count <= 3) return <BallsThree />
  if (count <= 5) return <BallsFive />
  return <BallsMany />
}

export const ConditionCard = ({ count, label, locked = false, step }: ConditionCardProps) => {
  const ConditionArt = CONDITION_ART_STEPS[step]

  if (ConditionArt) {
    return (
      <div className={classNames(styles.card, { [styles.locked]: locked })}>
        <ConditionArt label={label} />
      </div>
    )
  }

  if (count <= 1) {
    return (
      <div className={classNames(styles.card, { [styles.locked]: locked })}>
        <Condition1Art label={label} />
      </div>
    )
  }

  return (
    <div className={classNames(styles.card, { [styles.locked]: locked })}>
      {renderBalls(count)}
      <Label label={label} />
      <StarAnim width={180} height={90} className={styles.starAnim} />
    </div>
  )
}
